import API_BASE_URL from "../../../../../Constants";

export const updateBuilding = async (buildingId, buildingData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(buildingData),
      credentials: "include",
    }
  );
  if (!response.ok) throw new Error("Failed to update building");
  return response.json();
};
